import { useParams, Navigate, Route, Routes } from 'react-router'
import { useEffect, useState } from 'react'
import { SpinnerLoader } from 'shared/ui'
import { ChatbotRoutes } from 'entities/ExportRouters'
import { useEntitiesContext } from 'entities/EntitiesExport'
import { ChatbotInstructionType } from 'entities/Chatbot'
import { ChatbotPath } from 'pages/chatbot/route/chatbotPath'
import { Configure } from 'pages/chatbot/ui/UnifiedAgent/ui/Configure/Configure'
import { ChatbotEditV2Layout } from 'pages/chatbot/pages/chatbotEdit/layout/ChatbotEditV2Layout'
import { Chat } from 'pages/chatbot/ui/UnifiedAgent/ui/Chat/Chat'
import { AgentEditPreloadStore } from 'pages/chatbot/store/agentEditPreloadStore'
import { ChatbotEditOldPage } from '../ui/ChatbotEditOldPage'

export const ChatbotEditRouter = () => {
  const { featureFlagsStore } = useEntitiesContext()
  const { agentId } = useParams()
  const [preloadStore] = useState(() => new AgentEditPreloadStore())
  const [isLoading, setIsLoading] = useState(true)

  useEffect(() => {
    const load = async () => {
      if (agentId) await preloadStore.load(Number(agentId))
      setIsLoading(false)
    }
    load()
  }, [agentId])

  if (isLoading) return <SpinnerLoader ariaLabel='AgentEditRouter' />
  if (preloadStore.error || !preloadStore.data) return <Navigate to={ChatbotPath.texting} replace />

  const isUnified = preloadStore.data.type === ChatbotInstructionType.Unified

  if (!featureFlagsStore.unified_agent_enabled || !isUnified) {
    return (
      <Routes>
        <Route index element={<ChatbotEditOldPage initialData={preloadStore.data} />} />
        <Route path='*' element={<Navigate to={ChatbotPath.edit(Number(agentId))} replace />} />
      </Routes>
    )
  }

  return (
    <Routes>
      <Route element={<ChatbotEditV2Layout initialData={preloadStore.data} />}>
        <Route index element={<Navigate to={ChatbotRoutes.config} replace />} />
        <Route path={ChatbotRoutes.chat} element={<Chat />} />
        <Route path={ChatbotRoutes.config} element={<Configure />} />
      </Route>
      <Route
        path='*'
        element={
          <Navigate to={`/${ChatbotPath.root}/${agentId}/${ChatbotRoutes.config}`} replace />
        }
      />
    </Routes>
  )
}
